import { Icon, LinearProgress, makeStyles, Text, useTheme } from '@rneui/themed'
import { View } from 'react-native'

interface Props {
  progress: { current: number; total?: number }
  title: string
  iconName: string
  iconType: string
  description: string
  processingText?: string
  downloadingText?: string
  solid?: boolean
}
export function ProcessingView({
  description,
  iconName,
  iconType,
  progress,
  processingText,
  title,
  downloadingText,
  solid,
}: Props) {
  const styles = useStyles()
  const { theme } = useTheme()

  const total = progress.total && progress.total > 0 ? progress.total : 1
  const progressValue = Math.round(progress.current / total)
  return (
    <View style={styles.container}>
      <Icon
        name={iconName}
        type={iconType}
        size={50}
        solid={solid}
        containerStyle={styles.iconContainer}
      />
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.description}>{description}</Text>
      {progress.total && processingText ? (
        <Text style={styles.description}>{processingText}</Text>
      ) : downloadingText ? (
        <Text style={styles.description}>{downloadingText}</Text>
      ) : null}
      <LinearProgress
        value={progressValue}
        color={theme.colors.primary}
        style={styles.progressBar}
      />
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    alignItems: 'center',
    paddingHorizontal: 50,
    paddingTop: '50%',
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
  },
  description: {
    fontSize: 16,
    marginBottom: 20,
    textAlign: 'center',
  },
  iconContainer: { marginBottom: 20 },
  progressBar: {
    height: 10,
    borderRadius: 20,
  },
}))
